import React from "react";
import BookingAddOrUpdateContent from "../content/bookingAddOrUpdateContent";
import Layout from "../layout/Layout";

const BookingAdd = () => {
  return (
    <Layout>
      <BookingAddOrUpdateContent />
    </Layout>
  );
};

export default BookingAdd;
